import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 3.81a.7.7 0 0 1 .7-.7h4.867a.7.7 0 0 1 .435.151L9.433 4.4H17.3a.7.7 0 0 1 .7.7v11.09a.7.7 0 0 1-.7.7H2.7a.7.7 0 0 1-.7-.7zm1.4.7v10.98h13.2V5.8H9.189a.7.7 0 0 1-.436-.152L7.323 4.51z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.744 7.016a.5.5 0 0 1 .64 0l1.524 1.267a.5.5 0 0 1 0 .769l-1.524 1.267a.5.5 0 0 1-.64 0L8.22 9.052a.5.5 0 0 1 0-.77zm-.422 1.651.742.617.742-.617-.742-.617zm-2.118.376a.5.5 0 0 1 .64 0l1.524 1.268a.5.5 0 0 1 0 .768l-1.524 1.268a.5.5 0 0 1-.64 0L5.68 11.079a.5.5 0 0 1 0-.768zm5.08 0a.5.5 0 0 1 .64 0l1.523 1.268a.5.5 0 0 1 0 .768l-1.524 1.268a.5.5 0 0 1-.639 0l-1.524-1.268a.5.5 0 0 1 0-.768zm-5.502 1.652.742.617.742-.617-.742-.617zm5.08 0 .742.617.742-.617-.742-.617zM8.22 12.338l1.524-1.267a.5.5 0 0 1 .64 0l1.524 1.267a.5.5 0 0 1 0 .77l-1.524 1.266a.5.5 0 0 1-.64 0L8.22 13.107a.5.5 0 0 1 0-.769m1.102.385.742.617.742-.617-.742-.617z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=WorkAppFolderIcon20.js.map